import { IApplicationState } from '../../types/redux';

export const selectFinancePlatformEnabled = (state: IApplicationState) => state.calculator.financePlatformEnabled;
